import React, { useState } from 'react';
import { Box } from '@mui/material';
import GeneralResultsWrapper from './GeneralResults';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Autorização de Internação Hospitalar - Total',
    1: 'AIH - Especialidades'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <GeneralResultsWrapper />;
        case 1:
            return (
                <ServicesWrapper
                    module={{
                        sectionTitle: 'Total de AIH por Especialidade'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.SPECIALITIES_AIH,
                        url: 'governanceroom/dashboard/sihsus/aih/specialties'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        default:
            return null;
    }
};

const AIH = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Resultados Gerais',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Especialidades',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default AIH;